<template>
    <v-container>
        <main>
            <section class="diagnostic__offer">
                <h2 class="diagnostic__title">Диагностическая карта</h2>
                <p class="diagnostic__type">Техосмотр</p>
            </section>
            <section class="help">
                <header class="help__header">
                    <h3 class="help__title">Помощь в оформлении диагностической карты</h3>
                    <span class="help__type">Без предоплаты</span>
                </header>
                <div class="help__text">
                    <p>Диагностическая карта (техосмотр) необходима для автомобилей старше 3-х лет. Без диагностической карты оформить полис ОСАГО невозможно.</p>
                    <p>Оформление диагностической карты осуществляется станциями за 5 минут, которые имеют аккредитацию на проведения технического осмотра транспортных средств. Оплата за диагностическую карту осуществляется только после ее получения удобным для Вас способом, включая электронные деньги и переводы на банковские карты.</p>
                </div>
                <ul class="help__list">
                    <li class="help__item">Работаем без предоплаты</li>
                    <li class="help__item">Оформление диагностической карты - 5 минут</li>
                </ul>
            </section>
            <section class="document">
                <h4 class="document__title">Документы, которые потребуются для оформления диагностической карты</h4>
                <ul class="document__list">
                    <li class="document__item"><span>–</span> Паспорт транспортного средства;</li>
                    <li class="document__item"><span>–</span> СТС – свидетельство о регистрации транспортного средства;</li>
                    <li class="document__item"><span>–</span> Пробег (не обязательно точный, но желательно);</li>
                    <li class="document__item"><span>–</span> Марку автошин, установленных на автомобиле на день оформления;</li>
                    <li class="document__item"><span>–</span> Все эти данные необходимо внести в форму при заказе оформления диагностической карты.</li>
                </ul>
            </section>
            <section class="service-info">
                <div class="service-info__wrapper">
                    <div class="service-info__text">
                        <h3 class="service-info__title">501 автосервис на одном агрегаторе</h3>
                        <p>Получили диагностическую карту, внесенную в ЕАИСТО – можно приступать к покупке полиса ОСАГО. Полисы ОСАГО на агрегаторе в-автосервис.рф оформляются непосредственно в страховой компании без посредников. Стоимость полиса ОСАГО едина для всех страховых компаний. Агрегатор в-автосервис.рф осуществляет начисление кэш-бэка на Ваш счет от 10%. Диагностические карты оформляются станциями техосмотра для категорий – A, B, C, D, E Нужно ли иметь при себе распечатанную диагностическую карту? Нет не нужно. Оформление полиса eОСАГО (электронный полис ОСАГО) осуществляется онлайн. При оформлении полиса прикладывать файл нет необходимости. Сохраните pdf файл с Вашей диагностической картой, номер карты в любом случае будет находиться в базе ЕАИСТО. Мошенничество на рынке диагностических карт распространенная практика. Никогда не оформляйте диагностическую карту по цене ниже 500 рублей. Никогда не оплачивайте за диагностическую карту путем предоплаты – только после проверки ее по базе ЕАИСТО. Внесение в базу ГИБДД ЕАИСТО осуществляется без возможности удаления данных. Такие данные предоставляют не все операторы техосмотра и точно не предоставляют мошенники, работающие на рынке диагностических карт.</p>
                    </div>
                    <div class="service-info__img">
                        <img src="../../assets/images/service-phone.png" alt="phone" width="187" height="180">
                    </div>
                </div>
            </section>
            <section class="diagnostic__order">
                <h3 class="diagnostic__order-title">Заказать диагностическую карту</h3>
                <form action="#" class="diagnostic__form">
                    <div class="diagnostic__form-wrapper">
                        <div class="input__wrap input__fio">
                            <input type="text" placeholder="ФИО">
                        </div>
                        <div class="input__wrap">
                            <input type="text" placeholder="+7 (___) ___-__-__">
                        </div>
                        <div class="input__wrap">
                            <input type="text" placeholder="yourmail@domain.com">
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Город">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Марка">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Модель">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow input__wrap-small">
                            <input type="text" placeholder="Год">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="VIN-код">
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="Номер кузова">
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="Номер шасси">
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="Пробег">
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="Госномер">
                        </div>
                        <div class="input__wrap">
                            <input type="text" placeholder="Марка шин">
                        </div>
                        <div class="input__wrap">
                            <input type="text" placeholder="Масса без нагрузки, кг">
                        </div>
                        <div class="input__wrap">
                            <input type="text" placeholder="Максимальная масса, кг">
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Тип топлива">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Тип тормозной системы">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Категория ТС (ПТС)">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Категория ТС (ОКП)">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap-arrow">
                            <input type="text" placeholder="Документ">
                            <span><img src="../../assets/images/arrow-form.svg" alt="arrow" width="12" height="6"></span>
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="Серия">
                        </div>
                        <div class="input__wrap input__wrap-small">
                            <input type="text" placeholder="Номер">
                        </div>
                        <div class="input__wrap">
                            <input type="text" placeholder="Дата выдачи">
                        </div>
                        <div class="input__wrap input__who">
                            <input type="text" placeholder="Кем выдан">
                        </div>
                        <div class="checbox-type">
                            <label class="checkbox-label">
                                <input type="radio" name="type">
                                <span class="checkbox"></span>
                                <span class="checkbox__name">Собственник - иностранный гражданин</span>
                            </label>
                            <label class="checkbox-label">
                                <input type="radio" name="type">
                                <span class="checkbox"></span>
                                <span class="checkbox__name">Такси или автобус</span>
                            </label>
                        </div>
                    </div>

                    <div class="checkbox-agree">
                        <label class="checkbox-label">
                            <input type="checkbox">
                            <span class="checkbox"></span>
                            <span class="checkbox__name">Я соглашаюсь с <a href="#">условиями обработки персональных данных</a></span>
                        </label>
                    </div>
                    <button class="diagnostic__btn">Отправить данные</button>
                </form>
            </section>
            <article class="comment">
                <div class="comment__add-wrapper">
                    <h2 class="section-title">Истории наших клиентов</h2>
                    <a href="#" class="comment__add">добавить свою</a>
                </div>
                <div class="comment__chapter owl-carousel owl-theme" id="commentCarousel">
                    <div class="comment__wrapper comment-one">
                        <header class="comment__header">
                            <h3 class="comment__name"><span>От</span>Пётр Смирнов</h3>
                            <div class="comment__stars">
                                <div class="comment__stars-small">5<img src="../../assets/images/star.svg" alt="star" width="14" height="14"></div>
                                <div class="comment__stars-big">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/starempty.svg" alt="star" width="14" height="14">
                                </div>
                            </div>
                            <div class="comment__date">06-02-2020 15:02</div>
                        </header>
                        <ul class="comment__list">
                            <li class="comment__item">
                                <div class="comment__service">Авто:</div>
                                <div class="comment__brand">Volkswagen Golf V</div>
                            </li>
                            <li class="comment__item">
                                <div class="comment__service">Сервис:</div>
                                <div class="comment__brand">Авто Моторз на Тишинке</div>
                            </li>
                            <li class="comment__item">
                                <div class="comment__service">Услуга:</div>
                                <div class="comment__brand">Стёкла, фары <span><img src="../../assets/images/comment-arrow.svg" alt="arrow" width="11" height="6"></span> Замена лобового стекла</div>
                            </li>
                        </ul>
                        <section class="comment__text">
                            <h2 class="visually-hidden">Отзыв</h2>
                            <p>Сайт рыбатекст поможет дизайнеру, верстальщику, вебмастеру сгенерировать несколько абзацев более менее осмысленного текста рыбы на русском языке, а начинающему оратору отточить навык публичных выступлений в домашних условиях. При создании генератора мы использовали небезизвестный универсальный код речей. Текст генерируется абзацами случайным образом от двух до десяти предложений в абзаце, что позволяет сделать текст более привлекательным и живым... <button class="comment__open">читать всё</button><span>для визуально-слухового восприятия</span></p>
                        </section>
                        <div class="comment__audio audio">
                            <div class="audio__icon"></div>
                            <div class="audio__line"></div>
                            <p class="audio__time">0:15 / 0:52</p>
                        </div>
                    </div>
                    <div class="comment__wrapper comment-two">
                        <header class="comment__header">
                            <h3 class="comment__name">Джеймс Бонд</h3>
                            <div class="comment__stars">
                                <div class="comment__stars-small">5<img src="../../assets/images/star.svg" alt="star" width="14" height="14"></div>
                                <div class="comment__stars-big">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/starempty.svg" alt="star" width="14" height="14">
                                </div>
                            </div>
                            <div class="comment__date">06-02-2020 15:02</div>
                        </header>
                        <ul class="comment__list">
                            <li class="comment__item">
                                <div class="comment__service">Авто:</div>
                                <div class="comment__brand">Volkswagen Golf V</div>
                            </li>
                            <li class="comment__item">
                                <div class="comment__service">Сервис:</div>
                                <div class="comment__brand">Авто Моторз на Тишинке</div>
                            </li>
                            <li class="comment__item">
                                <div class="comment__service">Услуга:</div>
                                <div class="comment__brand">Стёкла, фары <span><img src="../../assets/images/comment-arrow.svg" alt="arrow" width="11" height="6"></span> Замена лобового стекла</div>
                            </li>
                        </ul>
                        <section class="comment__text">
                            <h2 class="visually-hidden">Отзыв</h2>
                            <p>Сайт рыбатекст поможет дизайнеру, верстальщику, вебмастеру сгенерировать несколько абзацев более менее осмысленного текста рыбы на русском языке, а начинающему оратору отточить навык публичных выступлений в домашних условиях. При создании генератора мы использовали небезизвестный универсальный код речей. Текст генерируется абзацами случайным образом от двух до десяти предложений в абзаце, что позволяет сделать текст более привлекательным и живым... <button class="comment__open">читать всё</button><span>для визуально-слухового восприятия</span></p>
                        </section>
                        <div class="comment__audio audio">
                            <div class="audio__icon"></div>
                            <div class="audio__line"></div>
                            <p class="audio__time">0:15 / 0:52</p>
                        </div>
                    </div>
                    <div class="comment__wrapper comment-three">
                        <header class="comment__header">
                            <h3 class="comment__name">Дональд Трамп</h3>
                            <div class="comment__stars">
                                <div class="comment__stars-small">5<img src="../../assets/images/star.svg" alt="star" width="14" height="14"></div>
                                <div class="comment__stars-big">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/star.svg" alt="star" width="14" height="14">
                                    <img src="../../assets/images/starempty.svg" alt="star" width="14" height="14">
                                </div>
                            </div>
                            <div class="comment__date">06-02-2020 15:02</div>
                        </header>
                        <ul class="comment__list">
                            <li class="comment__item">
                                <div class="comment__service">Авто:</div>
                                <div class="comment__brand">Volkswagen Golf V</div>
                            </li>
                            <li class="comment__item">
                                <div class="comment__service">Сервис:</div>
                                <div class="comment__brand">Авто Моторз на Тишинке</div>
                            </li>
                            <li class="comment__item">
                                <div class="comment__service">Услуга:</div>
                                <div class="comment__brand">Стёкла, фары <span><img src="../../assets/images/comment-arrow.svg" alt="arrow" width="11" height="6"></span> Замена лобового стекла</div>
                            </li>
                        </ul>
                        <section class="comment__text">
                            <h2 class="visually-hidden">Отзыв</h2>
                            <p>Сайт рыбатекст поможет дизайнеру, верстальщику, вебмастеру сгенерировать несколько абзацев более менее осмысленного текста рыбы на русском языке, а начинающему оратору отточить навык публичных выступлений в домашних условиях. При создании генератора мы использовали небезизвестный универсальный код речей. Текст генерируется абзацами случайным образом от двух до десяти предложений в абзаце, что позволяет сделать текст более привлекательным и живым... <button class="comment__open">читать всё</button><span>для визуально-слухового восприятия</span></p>
                        </section>
                        <div class="comment__audio audio">
                            <div class="audio__icon"></div>
                            <div class="audio__line"></div>
                            <p class="audio__time">0:15 / 0:52</p>
                        </div>
                    </div>
                </div>
            </article>
        </main>
    </v-container>
</template>

<script>
    export default {
        name: 'diagnostika'
    }
</script>

<style>
    @import '../../assets/css/service.css';
    @import '../../assets/css/diagnostic.css';
</style>